import { FirebaseApp, initializeApp } from 'firebase/app';
import { Analytics, getAnalytics, logEvent } from 'firebase/analytics';
import { Firestore, getFirestore } from 'firebase/firestore';
import { FirebaseStorage, getDownloadURL, getStorage } from 'firebase/storage';
import {
  Auth,
  getAuth,
  signInAnonymously,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  sendEmailVerification,
  sendPasswordResetEmail,
  User,
  UserCredential,
  signOut,
} from 'firebase/auth';

import FirebaseConfig from 'app/config/FirebaseConfig';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Initialize Firebase
const app: FirebaseApp = initializeApp(FirebaseConfig);
const db: Firestore = getFirestore(app);
const analytics: Analytics = getAnalytics(app);
const storage: FirebaseStorage = getStorage(app);
const auth: Auth = getAuth(app);

export {
  app as default,
  analytics,
  logEvent,
  db,
  storage,
  getDownloadURL,
  auth,
  signInAnonymously,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  sendEmailVerification,
  sendPasswordResetEmail,
  signOut,
};
export type { User, UserCredential };
